import React, { useEffect } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { withRouter } from "react-router-dom";
import PlaceIcon from "@mui/icons-material/Place";
import { postReached, postRecieve } from "../../services/driver";
import { Button } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Map from "../map/map";
function WayCard({ data, getData }) {
  // const { detail, daata, getData } = props;
  const [code, setCode] = React.useState(null);
  const handleSubmit = async (e) => {
    try {
      await postReached(e.id)
        .then(async (res) => {
          toast.success("با موفقیت انجام شد", {
            position: "bottom-left",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        })
        .then(getData())
        .catch((e) => {
          toast.error(e.response.data.message, {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            zIndex: 10000,
          });
        });
    } catch (e) {}
  };
  console.log(data);
  return (
    <>
      {/* // data?.map((data, i) => ( */}
      <Card
        sx={{
          width: 350,
          padding: "10px",
          alignSelf: "center",
          marginTop: "3vh",
          minHeight: 400,
          marginBottom: "3vh",
          textAlign: "right",
          height:"auto"
        }}
      >
        <CardContent>
          {/* <Divider variant="middle" sx={{ margin: "3vh" }} /> */}
          <Map
            description={data.description}
            destination_lat={data.destination_lat}
            destination_long={data.destination_long}
            origin_long={data.origin_long}
            origin_lat={data.origin_lat}
          />
          <Typography
            sx={{
              fontFamily: "SansX",
              fontSize: "14px",
              marginTop: "2vh",
              marginBottom: "2vh",
              direction: "rtl",
            }}
            component="div"
          >
            <PlaceIcon
              sx={{ marginBottom: "-10px", marginLeft: "8px", color: "gray" }}
            />{" "}
           مبدا: {data.OriginNeshan}
          </Typography>
          <Typography
            sx={{
              fontFamily: "SansX",
              fontSize: "14px",
              marginBottom: "2vh",
              direction: "rtl",
            }}
            component="div"
          >
            <PlaceIcon
              sx={{ marginBottom: "-10px", marginLeft: "8px", color: "gray" }}
            />{" "}
           مقصد: {data.DestinationNeshan}
          </Typography>
          <Typography
            sx={{
              fontFamily: "SansX",
              fontSize: "14px",
              marginBottom: "2vh",
              direction: "rtl",
            }}
            component="div"
          >
            {data.description}
          </Typography>
          {data.driver?.full_name ?
          <Typography
            sx={{
              fontFamily: "SansX",
              fontSize: "14px",
              marginBottom: "2vh",
              direction: "rtl",
            }}
            component="div"
          >
           راننده: {data.driver?.full_name}{data.driver?.full_name !== data.driver?.phone ? "/" + data.driver?.phone : null}
          </Typography> :null}
          <Typography
            sx={{
              fontFamily: "SansX",
              fontSize: "14px",
              marginBottom: "2vh",
              direction: "rtl",
            }}
            component="div"
          >
           تاریخ: {new Date(data.created_at).toLocaleDateString('fa-IR')}
          </Typography>
          
        </CardContent>
      </Card>
      <ToastContainer />
    </>
  );
}

export default withRouter(WayCard);
